export default __webpack_public_path__ + "static/media/icon_egyptianFeet_right.f72e6d76.png";